<div role="dialog" aria-labelledby="dialogTitle">
  <div class="modal-header">
    <h4 id="dialogTitle" role="header" class="modal-title module-title">
      @if(isEditMode){
        {{"learning.curve.dialog.edit.title" | translate}}
      }@else{
        {{"learning.curve.dialog.add.title" | translate}}
      }
    </h4>
    <button [disabled]="!enableCancel" type="button" value="Close" class="close" aria-label="Close"
            title="{{'dialog.box.close.tooltip'|translate}}"
            (click)="dismiss()">
      <span class="icon-Close" aria-hidden="true" ></span>
    </button>
  </div>
  <div class="modal-body">
    <wfm-plan-loading-overlay *ngIf="isLoading"></wfm-plan-loading-overlay>

    <div class="col-12">
      <form [formGroup]="learningCurveForm" (submit)="submit()">
        <div class="row group-title">
          <div class='col-12'>
            <span class="primary-text">{{planName}}</span>
          </div>
        </div>

        <!-- Name Field -->
        <div class="row">
          <div class='col-12 form-group'>
            <wfm-textbox #nameInput
                        (wfmTextboxEvent)="setName($event.target.value)"
                        inputName="name"
                        [wfmAutoComplete]="'off'"
                        [maxLength]="32"
                        inputId="name"
                        [required]="true"
                        [textValue]="learningCurveForm.get('name').value"
                        label="{{'learning.curve.dialog.name.label'|translate}}"
                        hasFocus=true
                        ngbAutofocus>
            </wfm-textbox>
          </div>
        </div>

        <!-- Contact Types Multi-select -->
        <div class="row">
          <div class='col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 form-group'>
            <label class="text-uppercase input-label" for="contactTypes">
              {{"learning.curve.dialog.contact.types.label"|translate}}
              <span class="text-danger">*</span>
            </label>
            <p-multiselect placeholder=" " #ctSelector
                          [options]="contactTypes()"
                          formControlName="contactTypes"
                          [showToggleAll]="false"
                          [virtualScroll]="true"
                          [virtualScrollItemSize]="40"
                          [virtualScrollOptions]="virtualScrollOptions"
                          optionLabel="value.label"
                          optionValue="value"
                          optionDisabled="value.disabled"
                          [showHeader]="true"
                          [filter]="false"
                          [overlayOptions]="{showTransitionOptions: '0ms', hideTransitionOptions: '0ms'}"
                          emptyFilterMessage="{{'search.no.results.msg'|translate}}"
                          styleClass="fullrow"
                          class="filterable">
              <ng-template let-value pTemplate="selectedItems">
                <esp-multi-select-content [items]="value" emptyMessage="learning.curve.dialog.contact.types.empty.selection"> </esp-multi-select-content>
              </ng-template>
              <ng-template pTemplate="header">
                <esp-multi-select-filter [multiSelect]="ctSelector" [displaySelectOptions]="false"></esp-multi-select-filter>
              </ng-template>
              <ng-template pTemplate="footer">
                <esp-multi-select-footer [multiSelect]="ctSelector"></esp-multi-select-footer>
              </ng-template>
              <ng-template let-item pTemplate="item">
                <esp-multi-select-item [item]="item"></esp-multi-select-item>
              </ng-template>
            </p-multiselect>
          </div>
        </div>

        <!-- Class Training Weeks -->
        <div class="row">
          <div class='col-12 form-group'>
            <label class="text-uppercase input-label" for="classTrainingWeeks">
              {{"learning.curve.dialog.class.training.weeks.label"|translate}}
              <span class="text-danger">*</span>
            </label>
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <p-inputnumber
                  formControlName="classTrainingWeeks"
                  mode="decimal"
                  [useGrouping]="false"
                  [minFractionDigits]="0"
                  [maxFractionDigits]="0"
                  [size]="20"
                  [min]="0"
                  name="classTrainingWeeksInput"
                  inputId="classTrainingWeeksInput"
                  autocomplete="off"
                  styleClass="training-weeks-input"
                ></p-inputnumber>

                <breeze-button buttonText="{{'learning.curve.dialog.update.table'|translate}}"
                             [isPrimary]="true"
                             class="update-table-btn"
                             btnSizeClass=""
                             [isDisabled]="!enableUpdateTable || disableTrainingWeeksField"
                             (clicked)="updateTable()">
                </breeze-button>
              </div>
            </div>
            <div *ngIf="learningCurveForm.get('classTrainingWeeks').errors" class="error-message">
              {{'learning.curve.dialog.class.training.weeks.validation' | translate: {'0': maxTrainingWeeks} }}
            </div>
            <div *ngIf="disableTrainingWeeksField" class="info-message">
              {{"learning.curve.dialog.training.weeks.disabled.msg" | translate}}
            </div>
          </div>
        </div>

        <!-- Learning Curve Grid -->
        <div class="row">
          <div class="col-12">
            <div class="table-list editable-grid multi-cell-edit">
              <ag-grid-angular class="ag-theme-balham"
                             style="width: 100%; height: 145px;"
                             [rowData]="gridData"
                             [rowClassRules]="rowClassRules"
                             [rowHeight]="36"
                             [headerHeight]="56"
                             [columnDefs]="columnDefs"
                             [defaultColDef]="defaultColDef"
                             [suppressHorizontalScroll]="false"
                             enableRangeSelection="true"
                             [enableFillHandle]="true"
                             [modules]="modules"
                             [suppressRowTransform]="true"
                             suppressCopyRowsToClipboard="true"
                             rowSelection="multiple"
                             [stopEditingWhenCellsLoseFocus]="true"
                             [components]="frameworkComponents"
                             [ensureDomOrder]="true"
                             [context]="gridContext"
                             (gridReady)="onGridReady($event)"
                             [animateRows]="false">
              </ag-grid-angular>
            </div>
          </div>
        </div>

      </form>
    </div>
  </div>
  <div class="modal-footer">
    <div class="modal-buttons">
      <breeze-button [isSecondary]="true"
                     buttonText="{{'plan.label.delete' | translate }}"
                     [isDisabled]="!enableDelete"
                     [ngbPopover]="deleteLearningCurveMsg"
                     popoverClass="delete-popup">
      </breeze-button>
    </div>
    <div class="modal-buttons">
      <breeze-button buttonText="{{'plan.cancel.btn'|translate}}"
                     id="cancel-btn"
                     [isSecondary]="true"
                     [isDisabled]="!enableCancel"
                     (clicked)="dismiss()"></breeze-button>

      <breeze-button buttonText="{{'plan.save'|translate}}"
                     id="accept-btn"
                     [isPrimary]="true"
                     [isDisabled]="!isFormValid || disableTable || isLoading || !hasChanges"
                     (clicked)="submit()"></breeze-button>
    </div>
  </div>
</div>
<ng-template #deleteLearningCurveMsg>
  <div class="message-delete">
    <p>{{"learning.curve.delete.warning.msg" | translate}} </p>
  </div>
  <div class="button-response">
    <breeze-button [isSecondary]="true" buttonText="{{'btn.cancel.label' | translate }}"></breeze-button>
    <breeze-button [isPrimary]="true" buttonText="{{'btn.confirm.label' | translate }}" (clicked)="submitDelete()"></breeze-button>
  </div>
</ng-template>
